import * as React from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  VStack,
  useMediaQuery,
} from "@chakra-ui/react";
import { Splide, SplideTrack, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "@splidejs/react-splide/css/core";
import styled from "styled-components";

export const Slides = ({ slidesRepeater, gslidesRepeater }: SlideProps) => {
  const backgroundColors = ["#B2BB42", "#49A3CB", "#D9A542"];
  const repeaterData = gslidesRepeater || slidesRepeater;

  const Div = styled.div`
    .splide__arrows {
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1.5rem;
    }
    .splide__arrow {
      background: #fff;
      border-radius: 0;
      position: relative;
      width: 100%;
      height: 3rem;
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      opacity: 1;
      border: 1px solid #000;
      padding: 0 40px;
    }
    .splide__arrow--prev {
      background-image: url("/left-icon.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
    .splide__arrow--next {
      background-image: url("/right-icon.svg");
      background-position: center;
      background-repeat: no-repeat;
      right: 0;
    }
    .splide__arrow svg {
      display: none;
    }
  `;

  const [isMobile] = useMediaQuery("(max-width: 640px)");

  return (
    <Div>
      <Stack
        mx={{ base: "0", md: "16", "2xl": "32" }}
        py={{ base: "0", md: "88px" }}
      >
        <Splide
          hasTrack={false}
          options={{
            breakpoints: {
              640: {
                maxWidth: "100%",
                m: "0",
              },
            },
            type: "loop",
            arrows: true,
            pagination: false,
          }}
        >
          <Stack direction={{ base: "column", md: "row" }} gap={0} h={"580px"}>
            <SplideTrack>
              {repeaterData &&
                repeaterData.map((item: any, index: number) => {
                  const bgColor =
                    backgroundColors[index % backgroundColors.length];
                  return (
                    <SplideSlide key={index}>
                      <Flex
                        flex={1}
                        pos={"relative"}
                        direction={"column"}
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                        top={{ base: "12", md: "16" }}
                      >
                        <Box mt={12} mx={{ base: "4", md: "0" }}>
                          <Image
                            loading="lazy"
                            zIndex={"-1"}
                            pl={{ base: "0", md: "10" }}
                            src={item.mainTitle.sourceUrl}
                          />
                          <VStack
                            pos="relative"
                            bg={bgColor}
                            fontSize={"xl"}
                            zIndex="999"
                            px={{ base: "4", md: "12" }}
                            py={{ base: "4", md: "10" }}
                            color="white"
                            w={"auto"}
                            maxW={"550px"}
                            alignItems={"flex-start"}
                          >
                            <Heading
                              textTransform={"uppercase"}
                              fontFamily={"TradeGothic LT Bold"}
                              fontWeight={700}
                            >
                              {item.boxTitle}
                            </Heading>
                            <Text
                              display={"flex"}
                              fontFamily={"TradeGothic LT"}
                              alignItems={"flex-start"}
                              fontSize={"lg"}
                              w={"100%"}
                              opacity={".8"}
                              lineHeight={"150%"}
                              dangerouslySetInnerHTML={{
                                __html: isMobile
                                  ? item.boxText.slice(0, 145)
                                  : item.boxText,
                              }}
                            />
                          </VStack>
                        </Box>
                      </Flex>
                      <Flex
                        flex={1}
                        pos={"absolute"}
                        top={0}
                        right={0}
                        alignItems={"flex-start"}
                        justifyContent={"flex-end"}
                        w={{ base: "100%", md: "75%" }}
                      >
                        <Image
                          loading="lazy"
                          w={{ base: "100%", "2xl": "100%" }}
                          maxW={"100%"}
                          h={{ base: "214px", md: "auto" }}
                          src={item.mainImg.sourceUrl}
                        />
                      </Flex>
                    </SplideSlide>
                  );
                })}
            </SplideTrack>
          </Stack>
        </Splide>
      </Stack>
    </Div>
  );
};

type SlideProps = {
  slidesRepeater?: [
    {
      boxTitle: string;
      boxText: string;
      mainTitle: {
        sourceUrl: string;
      };
      mainImg: {
        sourceUrl: string;
      };
    }
  ];
  gslidesRepeater?: [
    {
      boxTitle: string;
      boxText: string;
      mainTitle: {
        sourceUrl: string;
      };
      mainImg: {
        sourceUrl: string;
      };
    }
  ];
};
